<!-- CusCalendar -->
<template>
  <van-calendar
    v-model="show"
    type="range"
    :title="title"
    :min-date="minDate"
    :max-date="maxDate"
    :formatter="formatter"
    :default-date="null"
    @confirm="onConfirm"
    @close="onCancel"
  />
</template>

<script>
import Vue from 'vue'
import { Calendar } from 'vant'

Vue.use(Calendar)

export default {
  name: 'CusCalendar',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '日期选择'
    },
    start: {
      type: String,
      default: ''
    },
    end: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

    };
  },

  computed: {
    minDate() {
      let time = ''
      if (this.start) {
        let start = new Date(this.start)
        let now = new Date()
        time = now > start ? now : start
      } else {
        time = new Date()
      }
      return time
    },
    maxDate() {
      let time = ''
      if (this.end) {
        time = new Date(this.end)
      } else {
        time = new Date(new Date().setMonth((new Date()).getMonth() + 6))
      }
      return time
    }
  },

  components: {},

  methods: {
    // 自定义文案
    formatter(day) {
      if (day.type === 'start') {
        day.bottomInfo = '入住';
      } else if (day.type === 'end') {
        day.bottomInfo = '离店';
      }
      return day
    },
    // 取消选择
    onCancel() {
      this.$emit('listenCancelCalendar')
    },
    // 选择完成
    onConfirm(val) {
      this.$emit('listenConfirmCalendar', val)
    }
  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
</style>